import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'lexicon-api.vendasta-local.com',
  'test': '',
  'demo': 'lexicon-demo.apigateway.co',
  'prod': 'lexicon-prod.apigateway.co',
  'production': 'lexicon-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetSupportedLanguagesRequest {
  static fromProto(proto) {
    let m = new GetSupportedLanguagesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.componentName !== 'undefined') {
      toReturn['componentName'] = this.componentName;
    }
    return toReturn;
  }
}
class GetSupportedLanguagesResponse {
  static fromProto(proto) {
    let m = new GetSupportedLanguagesResponse();
    m = Object.assign(m, proto);
    if (proto.languages) {
      m.languages = proto.languages.map(Language.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.languages !== 'undefined' && this.languages !== null) {
      toReturn['languages'] = 'toApiJson' in this.languages ? this.languages.toApiJson() : this.languages;
    }
    return toReturn;
  }
}
class GetTranslationRequest {
  static fromProto(proto) {
    let m = new GetTranslationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.componentName !== 'undefined') {
      toReturn['componentName'] = this.componentName;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class GetTranslationResponse {
  static fromProto(proto) {
    let m = new GetTranslationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.translations !== 'undefined') {
      toReturn['translations'] = this.translations;
    }
    return toReturn;
  }
}
class GetTranslationsRequest {
  static fromProto(proto) {
    let m = new GetTranslationsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.componentNames !== 'undefined') {
      toReturn['componentNames'] = this.componentNames;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class GetTranslationsResponse {
  static fromProto(proto) {
    let m = new GetTranslationsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.translations !== 'undefined') {
      toReturn['translations'] = this.translations;
    }
    return toReturn;
  }
}
class InvalidateCacheRequest {
  static fromProto(proto) {
    let m = new InvalidateCacheRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.componentName !== 'undefined') {
      toReturn['componentName'] = this.componentName;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class Language {
  static fromProto(proto) {
    let m = new Language();
    m = Object.assign(m, proto);
    if (proto.languageStatistics) {
      m.languageStatistics = Statistics.fromProto(proto.languageStatistics);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    if (typeof this.languageName !== 'undefined') {
      toReturn['languageName'] = this.languageName;
    }
    if (typeof this.languageStatistics !== 'undefined' && this.languageStatistics !== null) {
      toReturn['languageStatistics'] = 'toApiJson' in this.languageStatistics ? this.languageStatistics.toApiJson() : this.languageStatistics;
    }
    return toReturn;
  }
}
class Statistics {
  static fromProto(proto) {
    let m = new Statistics();
    m = Object.assign(m, proto);
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.totalWords) {
      m.totalWords = parseInt(proto.totalWords, 10);
    }
    if (proto.translated) {
      m.translated = parseInt(proto.translated, 10);
    }
    if (proto.translatedWords) {
      m.translatedWords = parseInt(proto.translatedWords, 10);
    }
    if (proto.failing) {
      m.failing = parseInt(proto.failing, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.totalWords !== 'undefined') {
      toReturn['totalWords'] = this.totalWords;
    }
    if (typeof this.translated !== 'undefined') {
      toReturn['translated'] = this.translated;
    }
    if (typeof this.translatedWords !== 'undefined') {
      toReturn['translatedWords'] = this.translatedWords;
    }
    if (typeof this.failing !== 'undefined') {
      toReturn['failing'] = this.failing;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let LexiconApiService = /*#__PURE__*/(() => {
  class LexiconApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getTranslation(r) {
      const request = r.toApiJson ? r : new GetTranslationRequest(r);
      return this.http.post(this._host + "/lexicon.v1.Lexicon/GetTranslation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTranslationResponse.fromProto(resp)));
    }
    getTranslations(r) {
      const request = r.toApiJson ? r : new GetTranslationsRequest(r);
      return this.http.post(this._host + "/lexicon.v1.Lexicon/GetTranslations", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTranslationsResponse.fromProto(resp)));
    }
    invalidateCache(r) {
      const request = r.toApiJson ? r : new InvalidateCacheRequest(r);
      return this.http.post(this._host + "/lexicon.v1.Lexicon/InvalidateCache", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSupportedLanguages(r) {
      const request = r.toApiJson ? r : new GetSupportedLanguagesRequest(r);
      return this.http.post(this._host + "/lexicon.v1.Lexicon/GetSupportedLanguages", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSupportedLanguagesResponse.fromProto(resp)));
    }
  }
  LexiconApiService.ɵfac = function LexiconApiService_Factory(t) {
    return new (t || LexiconApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  LexiconApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LexiconApiService,
    factory: LexiconApiService.ɵfac,
    providedIn: 'root'
  });
  return LexiconApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { GetSupportedLanguagesRequest, GetSupportedLanguagesResponse, GetTranslationRequest, GetTranslationResponse, GetTranslationsRequest, GetTranslationsResponse, HostService, InvalidateCacheRequest, Language, LexiconApiService, Statistics };
